import { isQuotingToolAvailable } from 'modules/common/permissions';

import { initMaterialStore } from 'store/materials/sagas';

import MaterialListPage from './entry';

export default [
  {
    exact: true,
    path: '/processes/materials',
    component: MaterialListPage,
    saga: initMaterialStore,
    permissions: [isQuotingToolAvailable],
  },
];
